import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

//import Background_Myyja from '../../images/svg/Background_Myyja.svg'
//import Background_Vastaaja from '../../images/svg/Background_Vastaaja.svg';

import Luuri_Myyja from '../../images/svg/Luuri_Myyja.svg'
import Luuri_Vastaaja from '../../images/svg/Luuri_Vastaaja.svg'
import Luuri_Neutraali from '../../images/svg/Luuri_Neutraali.svg'

import './Setting.css'

const Setting = () => {
    const [phone, setPhone] = useState(Luuri_Myyja)
    const role = useSelector(state => state.role)

    // kuvasuhde ja sen mukaan full screen versio tai pelkkä mobiili

    useEffect(() => {
        //https://brettdewoody.com/modifying-body-attributes-in-react/
        if (window.innerWidth >= 410) {
            if (role === '') {
                document.body.classList.remove('buyer-background-image')
                document.body.classList.remove('seller-background-image')
                document.body.classList.add('neutral-background-image')
                setPhone(Luuri_Myyja) //TODO puhelin neutraaliksi
                //setPhone(Luuri_Neutraali)
            } else if (role === 'seller') {
                document.body.classList.add('seller-background-image')
                document.body.classList.remove('buyer-background-image')
                document.body.classList.remove('neutral-background-image')
                setPhone(Luuri_Myyja)
            } else {
                document.body.classList.add('buyer-background-image')
                document.body.classList.remove('seller-background-image')
                document.body.classList.remove('neutral-background-image')
                setPhone(Luuri_Vastaaja)
            }

            return
        }
        
        document.body.classList.remove('buyer-background-image')
        document.body.classList.remove('seller-background-image')
        document.body.classList.add('neutral-background-image')
    }, [role]) //TODO kun redux muuttuu

    return (
        <div>
            <div className='flex'>
                <img src={window.innerWidth >= 410 ? phone : null} className="image second-level phone" alt="" />
            </div>
            {/*<img src={Background_Myyja} className="image ground-level background" alt="" />*/}
        </div>
    )
}

export default Setting